import { createBrowserRouter } from 'react-router-dom';
import AuthPage from '../auth/AuthPage';
import OrganizationPage from '../organization/OrganizationPage';
import CustomersPage from '../customers/CustomersPage';
import CustomerPage from '../customers/customer/CustomerPage';
import TransfersPage from '../transfers/TransfersPage';
import AuthProtectedPage from '../auth/AuthProtectedPage';
import { RoutesTypes } from './routerTypes';
import RootLayout from './RootLayout';
import { WalletVerificationPage } from '../walletVerification/WalletVerificationPage';
import { KYCSuccessPage } from '../kyc/KYCSuccessPage';
import { WithDeveloperAccountPage } from '../backoffice/WithDeveloperAccountPage';

export const router = createBrowserRouter([
  {
    path: `/${RoutesTypes.Auth}`,
    element: <AuthPage />,
  },
  {
    path: `/${RoutesTypes.KycSuccess}`,
    element: <KYCSuccessPage />,
  },
  {
    path: `/${RoutesTypes.WalletVerification}/:verificationHash`,
    element: <WalletVerificationPage />,
  },

  {
    path: '/',
    element: (
      <AuthProtectedPage>
        <RootLayout />
      </AuthProtectedPage>
    ),
    children: [
      {
        path: RoutesTypes.Customers,
        element: (
          <WithDeveloperAccountPage>
            <CustomersPage />
          </WithDeveloperAccountPage>
        ),
      },
      {
        path: `${RoutesTypes.Customers}/:id`,
        element: <CustomerPage />,
      },
      {
        path: RoutesTypes.Transfers,
        element: (
          <WithDeveloperAccountPage>
            <TransfersPage />
          </WithDeveloperAccountPage>
        ),
      },
      {
        path: RoutesTypes.Organization,
        element: <OrganizationPage />,
      },
    ],
  },
]);
